import { render, staticRenderFns } from "./StatusAutomation.vue?vue&type=template&id=da5dcf2e&"
import script from "./StatusAutomation.vue?vue&type=script&lang=js&"
export * from "./StatusAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports